const LINKABLE_DELIVERY_INTEGRATIONS = ['DESPACHALO', 'ENVIAME', 'CABIFY'];
export default LINKABLE_DELIVERY_INTEGRATIONS;
